<template>
  <div :class="classnames">
    <popup @openchange="handlePopupOpenChange" ref="popup">

        <div slot="control" class="collection-search__form-group">
          <button class="collection-search__dropdown">
            <span>{{ activeCollection }}</span>
          </button>
        </div>

       <template slot="content">
        <div class="collection-search__top">
          <div class="collection-search__search">
            <input
              class="collection-search__search-input"
              :placeholder="`Search Collections`"
              :type="`text`"
              v-model="filtersSearch"
              ref="search"
            />
            <span class="collection-search__search-icon"></span>
          </div>
        </div>
        <div class="collection-search__bottom">
          <ul class="collection-search__options collection-search__static-options">
            <router-link
              :class="[
                `collection-search__option`,
                !filteredCollection && `collection-search__option--is-active`
              ]"
              :active-class="`collection-search__option--is-active`"
              :exact="true"
              :tag="`li`"
              :to="{ name: 'Products' }"
              @click.native="handleLinkClick"
            >
              <a class="collection-search__option-link">All Products</a>
            </router-link>
          </ul>
          <ul class="collection-search__options collection-search__dynamic-options" v-if="filteredCollection">
            <router-link
              v-for="collection in filteredCollection"
              class="collection-search__option"
              :active-class="`collection-search__option--is-active`"
              :key="collection.id"
              :tag="`li`"
              :to="{ name: 'Product Collection', params: { id: collection.id }, title: collection.title }"
               @click.native="handleLinkClick"
            >
              <a class="collection-search__option-link">{{ collection.title }}</a>
            </router-link>
          </ul>
          <div class="collection-search__no-match" v-else>
            <p class="collection-search__no-match-text">No matches found.</p>
          </div>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
  import _orderBy from 'lodash/orderBy'
  import InteractiveSvgIcon from '@/components/InteractiveSvgIcon'
  import Popup from '@/components/Popup/Popup'
  import SvgIconHamburger from '@/svgs/SvgIconHamburger'
  import SvgIconCaretDown from '@/svgs/SvgIconCaretDown'

  import { bem } from '@/mixins/bem.js'

  export default {
    name: 'CollectionSearch',
    components: {
      'interactive-svg-icon': InteractiveSvgIcon,
      'popup': Popup,
      'svg-icon-hamburger': SvgIconHamburger,
      SvgIconCaretDown
    },
    mixins: [ bem ],
    props: {
      activeCollection: {
        type: String
      },
      collections: {
        type: Array
      },
      items: {
        type: Array
      }
    },
    data: function () {
      return {
        filtersSearch: '',
        isPopupOpen: false
      }
    },
    created: function () {
    },
    mounted () {
      this.setDynamicOptionsHeight()
    },
    computed: {
      filteredCollection: function () {
        if (this.filtersSearch === '') {
          return this.items
        }

        let results = this.items.filter(($el) => {
          const title = $el.title.toLowerCase()
          const inputValue = this.filtersSearch.toLowerCase()

          const isValueInTitle = title.indexOf(inputValue) !== -1

          return isValueInTitle
        })

        if (results.length === 0) {
          results = null
        } else {
          results = this.filterOrder(results)
        }

        return results
      }
    },
    methods: {
      filterOrder (array) {
        return _orderBy(array, ['title'])
      },
      forceClosePopup () {
        const $popup = this.$refs.popup

        $popup.close()
      },
      handleLinkClick () {
        this.forceClosePopup()
      },
      handlePopupOpenChange: function (isPopupOpen) {
        this.isPopupOpen = isPopupOpen

        if (!isPopupOpen) {
          const that = this

          // wait for close animation to complete
          setTimeout(function () {
            that.resetFilter()
          }, 1000)
        }
      },
      resetFilter () {
        this.filtersSearch = ''
      },
      setDynamicOptionsHeight () {
        const {
          $el: $component
        } = this

        const $dynamicOptions = $component.querySelector(`.collection-search__dynamic-options`)

        if ($dynamicOptions) {
          // const $item = $dynamicOptions.querySelector(`.collection-search__option`)

          // const itemHeight = $item.clientHeight

          // TODO
          // move this magic number to const
          $dynamicOptions.style.maxHeight = '280px'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../scss/abstracts/__dir';
@import '../../scss/global/__dir';

$ns: '.collection-search';

#{$ns} {

  &__search-input {
    @include placeholder {
      font-size: 13px;
    }
    color: $black;
    font-size: 13px;
    background-color: transparent;
    border: none;
    display: inline-block;
    flex-grow: 1;
    height: 38px;
    letter-spacing: 0;
    line-height: 38px;
    margin: 0;
    padding: 0;
    width: auto;
  }

  &__dropdown {
    background-color: rgba(255, 255, 255, 0);
    border: none;
    color: #999;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    font-size: 15px;
    height: 51px !important;
    line-height: 51px !important;
    padding: 0 18px !important;
    position: relative;
    text-align: right;
    width: 100%;
    min-width: 200px;
    background-image: url('../../assets/images/icon-chevron-down.svg');
    background-repeat: no-repeat;
    background-position: right 15px center;
    @include breakpoint($desktop) {
      width: 20vw;
    }
    @include breakpoint(1600px) {
      width: 30vw;
    }

  }

  &__bottom {}

    &__dynamic-options {
      overflow: auto;

      #{$ns}__option {
        &:last-child {
          border-radius: 0 0 3px 3px;
        }
      }
    }

    &__no-match {
      padding: 16px;
    }

    &__option {
      color: color('dusty-gray');
      cursor: pointer;
      font-size: 0;
      position: relative;

      &:after {
        background-color: color('black');
        content: '';
        display: none;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 4px;
      }

      &:hover,
      &--is-active {
        color: color('black');
        //font-family: $font-primary-medium;
        background-color: #f9f9f9;

        &:after {
          display: block;
        }
      }
    }

    &__option-link {
      color: inherit;
      display: inline-block;
      font-size: 15px;
      height: 40px;
      line-height: 40px;
      overflow: hidden;
      padding: 0 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      color: #444;
    }


    &__search {
      background-color: #fdfdfe;
      //border-radius: 20px;
      border-radius: 4px;
      border: 1px solid #e5e5e5;
      display: flex;
      height: 40px;
      padding: 0 16px;
      justify-content: space-between;
      min-width: 266px;
    }

    &__search-icon {
      color: #999;
      height: 38px;
      margin-left: 12px;
      position: relative;
      width: 16px;

      @include icon($icon-search);

      &:before {
        transform: scale(-1, 1);
        font-weight: bold;
        font-size: 12px;
        line-height: 17px;
        margin: auto;
        height: 17px;
        bottom: 0;
      }
    }



    &__form-group {
      //margin-top: 16px;
      background-color: white;
      border-radius: 3px;
      border: 1px solid #e4e4e4;
      //margin-bottom: 15px;
      box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.09);
      @include breakpoint($tablet) {
        margin-right: 15px;
        margin-bottom: 0;
      }

    }

    &__top {
      padding: 12px 14px;
    }

    .interactive-svg-icon {
      height: 38px;
      width: 47px;

      @include button-appearance-small;

      &--is-active {
        @include button-appearance-when-active;
      }
    }

    .popup-content {
      @include popup-box-appearance;
      background-color: #ffffff;
      border-radius: 3px;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.22) !important;
    }
  }
</style>


// WEBPACK FOOTER //
// src/js/components/CollectionSearch.vue